import React from 'react';
import TextField from '../../components/TextField/TextField.jsx';

// @rjsf/mui marks required fields by passing `required` straight to MUI's TextField/
// InputLabel, which appends " *" to the label automatically. Our TextField doesn't do
// that, so append it ourselves (matching material-ui).
const withRequiredMark = (label, required) => (required && label ? `${label} *` : label);

/** Renders the standard text/number <input> for every schema type that isn't select/checkbox. */
const BaseInputTemplate = ({
  id,
  value,
  disabled,
  readonly,
  required,
  label,
  hideLabel,
  placeholder,
  schema,
  type,
  onChange,
  onBlur,
  onFocus,
}) => {
  const isNumeric = type === 'number' || schema?.type === 'integer' || schema?.type === 'number';

  const handleChange = (newValue) => {
    if (newValue === '') {
      onChange(undefined);
      return;
    }
    if (!isNumeric) {
      onChange(newValue);
      return;
    }
    const parsed = schema?.type === 'integer' ? parseInt(newValue, 10) : parseFloat(newValue);
    onChange(Number.isNaN(parsed) ? undefined : parsed);
  };

  return (
    <TextField
      id={id}
      label={hideLabel ? undefined : withRequiredMark(label, required)}
      floatingLabel
      type={isNumeric ? 'number' : 'text'}
      value={value ?? ''}
      placeholder={placeholder}
      required={required}
      disabled={disabled || readonly}
      min={schema?.minimum}
      max={schema?.maximum}
      fullWidth
      onChange={handleChange}
      onBlur={(event) => onBlur?.(id, event?.target?.value)}
      onFocus={(event) => onFocus?.(id, event?.target?.value)}
    />
  );
};

export default BaseInputTemplate;
